import React, { FC, CSSProperties, ReactNode } from 'react';

import { Logo, Container, TitleData, Title } from './styles';

interface ITitleContainer {
  title?: string;
  imgSrc?: string;
  style?: CSSProperties;
  children?: ReactNode;
}

export const TitleContainer: FC<ITitleContainer> = ({ title, imgSrc, style, children }) => (
  <Container style={style}>
    {imgSrc && <Logo src={imgSrc} />}
    {title && (
      <Title>
        <TitleData>{title}</TitleData>
      </Title>
    )}
    {children}
  </Container>
);
